import * as React from 'react';
import styled from 'styled-components';
import { caption1 } from '@westwing/ui-kit/typography';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import Text from '@ids/components/Typography/Text';
import { SerializedPriceTier } from '@ids/types/now-api';

const StyledPrice = styled.div`
    margin-bottom: 20px;
    ${forTablet`
        display: flex;
        align-items: center;
    `}
`;

const StyledPriceAmount = styled(Text).attrs(() => ({ as: 'div' }))`
    margin-right: 5px;
    margin-bottom: 0;
    & p {
        margin: 0;
    }
`;

const StyledPerRoomText = styled.div`
    ${caption1}
    color: ${({ theme }) => theme.colors.charcoal100};
    font-size: 10px;
    ${forTablet`
        font-size: 12px;
    `}
`;

export const usePrice = (priceTier: SerializedPriceTier) => {
    if (!priceTier?.promotionalPrice?.price && !priceTier?.price) {
        return null;
    }

    if (!priceTier?.promotionalPrice?.price) {
        return priceTier.price;
    }

    const now = Date.now();
    const startDate = new Date(priceTier.promotionalPrice.startDate).getTime();
    const endDate = new Date(priceTier.promotionalPrice.endDate).getTime();

    if (startDate < now && endDate > now) {
        return (
            <div
                data-testid="tier-promotional-price"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: priceTier.promotionalPrice.price }}
            />
        );
    }

    return priceTier.price;
};

export const Price = ({ priceTier }: { priceTier: SerializedPriceTier }) => {
    const price = usePrice(priceTier);

    return (
        <StyledPrice>
            <StyledPriceAmount>{price}</StyledPriceAmount>
            <StyledPerRoomText>{priceTier.perRoomText}</StyledPerRoomText>
        </StyledPrice>
    );
};
